import { render, staticRenderFns } from "./WalletTopup.vue?vue&type=template&id=1aed516e&scoped=true&"
import script from "./WalletTopup.vue?vue&type=script&lang=js&"
export * from "./WalletTopup.vue?vue&type=script&lang=js&"
import style0 from "./WalletTopup.vue?vue&type=style&index=0&id=1aed516e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed516e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VImg,VRow})
